/* setup measurements history chart and draw initial bars
 *
 * after that, the bar data is updated via `./update_bars.js`
 *
 */

import * as d3 from '../../scripts/lib/d3.js'
import drawBars from './draw_bars.js'
import drawExceedLine from './draw_exceed_line.js'
import {toDate} from './date.js'

export default ({
  element,
  data,
  height=100,
  width=200,
  margin={
    top: 20,
    right: 10,
    bottom: 20,
    left: 25
  }
}) => {
  width = width - margin.left - margin.right

  const x = d3.scaleTime().rangeRound([0, width])
    .domain([toDate('2000-01-01'), toDate('2016-01-01')])
  const y = d3.scaleLinear().rangeRound([height, 0])
    .domain([0, 500])

  const svg = d3.select(element)
    .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .attr('class', 'history-chart__svg')
    .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

  svg.append('g')
      .attr('class', 'axis axis--x')
      .attr('transform', 'translate(0,' + height + ')')
      .call(d3.axisBottom(x).ticks(4))

  svg.append('g')
      .attr('class', 'axis axis--y')
      .call(d3.axisLeft(y).tickValues([50, 250, 500]))
    .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', 6)
      .attr('dy', '0.71em')
      .style('text-anchor', 'end')
      .text('mg Nitrat')

  // draw initial bars and return chart stuff
  const selection = svg.selectAll('.history-chart__bar').data(data).enter()
  drawBars({selection, x, y, height})

  // draw exceeding line
  drawExceedLine({svg, y, width})

  return {svg, x, y, height, width}
}



// WEBPACK FOOTER //
// ./src/components/station-infobox/init_chart.js